import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { combineLatest, map, switchMap } from 'rxjs';
import { UserGroupsService } from './groups/user-groups.service';
import { PermissionsService } from './permissions.service';

export const postLoginRedirectGuard = () => {
    const router = inject(Router);
    const permissionsService = inject(PermissionsService);
    const groupsService = inject(UserGroupsService);

    return permissionsService.permissions$.pipe(
        switchMap((permissions) =>
            combineLatest([
                groupsService.hasAnyGroup(permissions.partner.read),
                groupsService.hasAnyGroup(permissions.partnerServices.read),
            ])
        ),
        map(([canReadPartners, canReadServices]) => {
            if (canReadPartners) {
                return router.createUrlTree(['/customers']);
            }
            if (canReadServices) {
                return router.createUrlTree(['/services']);
            }
            return router.createUrlTree(['/unauthorized']);
        })
    );
};
